export class GetDuplicateBorrowers {
    static readonly type = '[DuplicateBorrowers] GetDuplicateBorrowers';
    constructor(public borrowerId: number) {}
}
export class ClearDuplicateBorrowers {
    static readonly type = '[DuplicateBorrowers] ClearDuplicateBorrowers';
    constructor() {}
}
